import { useState } from 'react'
import { Box, Button, Stack, TextField, Tooltip } from '@mui/material'
import { generaLinkCliente } from './link-cliente'
import { useServizi } from '../servizi/ServiziProvider'
import { ETICHETTA_DICHIARANTE } from '../anagrafiche/etichette-dichiarante'
import type { DettaglioImpianto } from '../anagrafiche/impianto.api'

interface Props {
  readonly impianto: DettaglioImpianto
}

export function DatiLicenza({ impianto }: Props) {
  const { eAttivo } = useServizi()
  const [link, setLink] = useState<string | null>(null)
  const [errore, setErrore] = useState<string | null>(null)
  const attivo = eAttivo('dashboardUtenteFinale')

  async function suGeneraLink() {
    setErrore(null)
    try {
      setLink(await generaLinkCliente(impianto.id))
    } catch (e) {
      setErrore(e instanceof Error ? e.message : 'errore imprevisto')
    }
  }

  return (
    <Box>
      <Stack spacing={2} sx={{ maxWidth: 420 }}>
        <TextField
          label="Tipologia dichiarante"
          value={ETICHETTA_DICHIARANTE[impianto.tipologiaDichiarante] ?? impianto.tipologiaDichiarante}
          slotProps={{ input: { readOnly: true } }}
        />
        <TextField
          label="Codice destinatario officina"
          value={impianto.codiceDestinatarioOfficina ?? '—'}
          slotProps={{ input: { readOnly: true } }}
        />
      </Stack>
      <Box sx={{ mt: 3 }}>
        {errore && <p role="alert">{errore}</p>}
        {link ? (
          <TextField label="Link cliente" value={link} fullWidth slotProps={{ input: { readOnly: true } }} />
        ) : (
          <Tooltip title={attivo ? '' : 'Attiva il modulo Dashboard utente finale per generare il link'}>
            <span>
              <Button variant="outlined" disabled={!attivo} onClick={() => void suGeneraLink()}>
                Genera link cliente
              </Button>
            </span>
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}
